export const toPath = (...segments) => {
    return segments.reduce((prev, curr) => `${prev}/${(curr || '').replace(/^\// ,'').replace(/\/$/, '')}`, '');
}
